export const STUDIO_API_BASE = "/studio-api";

export const STUDIO_API_CONFIG = {
  apiUrl: `${STUDIO_API_BASE}/amazon-llm`,
  schemaApi: {
    saveUrl: `${STUDIO_API_BASE}/save-schema`,
    listUrl: `${STUDIO_API_BASE}/schemas`,
    getUrl: `${STUDIO_API_BASE}/schemas`,
  },
};

export type SchemaFolder = "DRAFT" | "PENDING_APPROVAL" | "APPROVED";

export const STUDIO_BROWSER_FOLDERS: { id: SchemaFolder; label: string }[] = [
  { id: "DRAFT", label: "Draft" },
  { id: "PENDING_APPROVAL", label: "Pending Approval" },
  { id: "APPROVED", label: "Approved" },
];

export const SCHEMA_NAME_PATTERN = /^[a-zA-Z0-9_-]{1,128}$/;
